import {usePathname} from 'next/navigation';
import {useMemo} from 'react';

import {AppCategory} from '@web-catalog/types';

import {useCategoriesAtomValue} from '@web-catalog/store';

import {findCategoryData, parseCategory} from '@web-catalog/utils';

type CategoriesGroups = {
  categories: Array<AppCategory>;
  appCategories: Array<AppCategory>;
  gameCategories: Array<AppCategory>;
  activeCategory: AppCategory | null;
};

export const useCategories = (isGamePage?: boolean): CategoriesGroups => {
  const path = usePathname();

  const {appsCategories, gamesCategories} = useCategoriesAtomValue();

  const categories = useMemo<Array<AppCategory>>(() => {
    return isGamePage ? gamesCategories : appsCategories;
  }, [isGamePage, gamesCategories, appsCategories]);

  const [pathUrl] = path?.split('?') || [''];

  const category = parseCategory(pathUrl);

  const activeCategory = useMemo(
    () => (category ? findCategoryData(categories, category) : null),
    [categories, category],
  );

  return {
    categories,
    appCategories: appsCategories,
    gameCategories: gamesCategories,
    activeCategory,
  };
};

export const useCategoryToCategoryName = () => {
  const {appCategories, gameCategories} = useCategories();

  return useMemo<Record<string, string>>(
    () =>
      [...gameCategories, ...appCategories].reduce(
        (a, x) => {
          a[x.category] = x.categoryName;

          return a;
        },
        {} as Record<string, string>,
      ),
    [gameCategories, appCategories],
  );
};
